import classNames from "classnames"
import React, { FC } from "react"

import { i18n } from "@/i18n"

import styles from "./index.module.scss"

interface KeyboardProps {
    type: "number" | "full" | "default"
    value: string
    maxLength: number
    onKeyPress: (key: string) => void
    onValueChange: (value: string) => void
    onClear: () => void
    onConfirm: () => void
}

export const Keyboard: FC<KeyboardProps> = ({
    type,
    value,
    maxLength,
    onKeyPress,
    onValueChange,
    onClear,
    onConfirm,
}) => {
    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const string = e.target.value
        let res = ""
        for (let i = 0; i < maxLength; i++) {
            const char = string[i]
            if (
                (type === "full"
                    ? /^[0-9A-Z]$/i
                    : type === "number"
                      ? /^[0-9]$/i
                      : /^[0123456789abcdefghjkmn]$/i
                ).test(char)
            ) {
                res += char.toUpperCase()
            }
        }
        onValueChange(res)
    }

    const handleBackspace = () => {
        onValueChange(value.replace(/.$/, ""))
    }

    return (
        <div className={styles.modal}>
            <div className={styles.shadow}></div>
            <div
                className={classNames(
                    styles.value,
                    !value && styles.empty,
                )}
            >
                <input
                    className={styles.input}
                    type="text"
                    inputMode={"none"}
                    // biome-ignore lint/a11y/noAutofocus: 键盘弹窗需要自动聚焦输入框
                    autoFocus
                    value={value}
                    onChange={handleInputChange}
                    readOnly={!!value}
                />
                {value ? (
                    <div
                        className={styles.backspace}
                        onClick={handleBackspace}
                    >
                        <img
                            src={require("@/assets/imgs/recall/backspace.svg")}
                            alt=""
                        />
                    </div>
                ) : null}
            </div>
            <div
                className={classNames(
                    styles.keyboard,
                    type === "full" && styles.full,
                )}
            >
                {type === "full" ? (
                    <>
                        <div className={styles.row}>
                            {"0123456789".split("").map((key) => (
                                <div
                                    key={key}
                                    className={styles.button}
                                    onClick={() => onKeyPress(key)}
                                >
                                    {key}
                                </div>
                            ))}
                        </div>
                        <div className={styles.row}>
                            {"QWERTYUIOP".split("").map((key) => (
                                <div
                                    key={key}
                                    className={styles.button}
                                    onClick={() => onKeyPress(key)}
                                >
                                    {key}
                                </div>
                            ))}
                        </div>
                        <div className={styles.row}>
                            {"ASDFGHJKL".split("").map((key) => (
                                <div
                                    key={key}
                                    className={styles.button}
                                    onClick={() => onKeyPress(key)}
                                >
                                    {key}
                                </div>
                            ))}
                        </div>
                        <div className={styles.row}>
                            {"ZXCVBNM".split("").map((key) => (
                                <div
                                    key={key}
                                    className={styles.button}
                                    onClick={() => onKeyPress(key)}
                                >
                                    {key}
                                </div>
                            ))}
                            <div
                                className={classNames(
                                    styles.button,
                                    styles.danger,
                                )}
                                onClick={onClear}
                            >
                                {i18n.getRecall("common.clear")}
                            </div>
                            <div
                                className={classNames(
                                    styles.button,
                                    styles.submit,
                                )}
                                onClick={onConfirm}
                            >
                                {i18n.getRecall("common.confirm")}
                            </div>
                        </div>
                    </>
                ) : type === "number" ? (
                    <>
                        <div className={styles.row}>
                            {"789".split("").map((key) => (
                                <div
                                    key={key}
                                    className={styles.button}
                                    onClick={() => onKeyPress(key)}
                                >
                                    {key}
                                </div>
                            ))}
                        </div>
                        <div className={styles.row}>
                            {"456".split("").map((key) => (
                                <div
                                    key={key}
                                    className={styles.button}
                                    onClick={() => onKeyPress(key)}
                                >
                                    {key}
                                </div>
                            ))}
                        </div>
                        <div className={styles.row}>
                            {"123".split("").map((key) => (
                                <div
                                    key={key}
                                    className={styles.button}
                                    onClick={() => onKeyPress(key)}
                                >
                                    {key}
                                </div>
                            ))}
                        </div>
                        <div className={styles.row}>
                            {"0".split("").map((key) => (
                                <div
                                    key={key}
                                    className={styles.button}
                                    onClick={() => onKeyPress(key)}
                                >
                                    {key}
                                </div>
                            ))}
                            <div
                                className={classNames(
                                    styles.button,
                                    styles.danger,
                                )}
                                onClick={onClear}
                            >
                                {i18n.getRecall("common.clear")}
                            </div>
                            <div
                                className={classNames(
                                    styles.button,
                                    styles.submit,
                                )}
                                onClick={onConfirm}
                            >
                                {i18n.getRecall("common.confirm")}
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className={styles.row}>
                            {"ABC789".split("").map((key) => (
                                <div
                                    key={key}
                                    className={styles.button}
                                    onClick={() => onKeyPress(key)}
                                >
                                    {key}
                                </div>
                            ))}
                        </div>
                        <div className={styles.row}>
                            {"DEF456".split("").map((key) => (
                                <div
                                    key={key}
                                    className={styles.button}
                                    onClick={() => onKeyPress(key)}
                                >
                                    {key}
                                </div>
                            ))}
                        </div>
                        <div className={styles.row}>
                            {"GHJ123".split("").map((key) => (
                                <div
                                    key={key}
                                    className={styles.button}
                                    onClick={() => onKeyPress(key)}
                                >
                                    {key}
                                </div>
                            ))}
                        </div>
                        <div className={styles.row}>
                            {"KMN0".split("").map((key) => (
                                <div
                                    key={key}
                                    className={styles.button}
                                    onClick={() => onKeyPress(key)}
                                >
                                    {key}
                                </div>
                            ))}
                            <div
                                className={classNames(
                                    styles.button,
                                    styles.danger,
                                )}
                                onClick={onClear}
                            >
                                {i18n.getRecall("common.clear")}
                            </div>
                            <div
                                className={classNames(
                                    styles.button,
                                    styles.submit,
                                )}
                                onClick={onConfirm}
                            >
                                {i18n.getRecall("common.confirm")}
                            </div>
                        </div>
                    </>
                )}
            </div>
        </div>
    )
}

